import React from 'react'
import expresslogo from "../../express_logo.png"

const Express = () => {
    return (
        <div style={{minHeight: 120}}>
            <div >
                <div className="card card-body" style={{width: 300}}>
                    <article >
                        <img  src={expresslogo} alt=""/>
                    </article>
                        This is some placeholder content for a horizontal collapse. It's hidden by default and shown when triggered.
                </div>
            </div>
        </div>
    )
}

export default Express
